export const productName =  () => {
    return "discover"
};

const RestAuthManager = require('./C2RestAuthManager');

export const API = RestAuthManager.API;
export const Auth = RestAuthManager.Auth;
export const logout = RestAuthManager.logout;
export const hasSessionCookie = RestAuthManager.hasSessionCookie;
export default RestAuthManager;

const getUser = async () => {
    return  await RestAuthManager.getUser();
}

const changePassword = async (oldPass, newPass) => {
    return await RestAuthManager.changePassword(oldPass, newPass);
}


export { getUser, changePassword };